import { render } from "./FilterMenuAnchorLinks.vue?vue&type=template&id=06d05946"
import script from "./FilterMenuAnchorLinks.vue?vue&type=script&lang=js"
export * from "./FilterMenuAnchorLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__